/**
 * @generated SignedSource<<303c78ea65766e95fe6e49ee8299a1d5>>
 * @relayHash 3915650f8eb2fa0cca35772da0cd370c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 92859d529606502deea4be34ba0966f6b4fc84c5666c803fd73b800c66b33c06

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { SupportWebsiteOverviewQuery } from './SupportWebsiteOverviewQuery.graphql';

const node: PreloadableConcreteRequest<SupportWebsiteOverviewQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "92859d529606502deea4be34ba0966f6b4fc84c5666c803fd73b800c66b33c06",
    "metadata": {},
    "name": "SupportWebsiteOverviewQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
